import React, { useState } from "react";
import { connect } from "react-redux";
import { useMountEffect, useUpdateEffect } from "../../../../hooks/LifeCycle";
import TittleLine from "../../../../components/Common/TittleLine";
import { Section } from "../../../../components/CustomLayout/CustomLayoutStyles";
import CustomTable from "../../../../components/CustomTable/CustomTable";
import StandVirtualReportesBusquedaForm from "../components/StandVirtualReportesBusquedaForm";
import { QUERY_RANGE, TIME_SCALE } from "../../../../utils/Constant";
import moment from "moment";
import { camposCompletos } from "../../../../utils/ValidationUtil";
import { ALERTAS_GENERICAS } from "../../../../utils/AlertasGenericas";
import Pagination from "../../../../components/CustomTable/Pagination";
import CheckRender from "../../../../components/Common/CheckRender";
import { isObjectEmpty } from "../../../../utils/ObjectUtil";
import CustomAlert from "../../../../components/Common/CustomAlert";
import { mostrarErrorGenerico } from "../../../../utils/AlertUtils";
import ModalLoader from "../../../../components/Common/ModalLoader";
import useEmpresa from "../../../../hooks/useEmpresa";
import ReportesActions from "../../../../stores/reportes/Actions";

const StandVirtualReportesScreen = (props) => {
  const empresa = useEmpresa();

  const [formData, setFormData] = useState({
    fechaDesde: moment()
      .subtract(QUERY_RANGE.uno, TIME_SCALE.dia)
      .format("YYYY-MM-DD"),
    fechaHasta: moment().format("YYYY-MM-DD"),
    estatus: 0, // 0 representa "Todos"
    tipoPss: "Medico",
    codigoPss: "",
    buscar: "",
    tipoBusqueda: "numeroSolicitud"
  });

  const [showAlert, setShowAlert] = useState(false);
  const [alertConfig, setAlertConfig] = useState({});
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);

  useMountEffect(() => {
    let startDate = moment(new Date())
      .subtract(QUERY_RANGE.uno, TIME_SCALE.dia)
      .format("YYYY-MM-DD");

    let today = moment(new Date()).format("YYYY-MM-DD");

    setFormData((prevState) => {
      return {
        ...prevState,
        fechaDesde: startDate,
        fechaHasta: today
      };
    });
  });

  /**
   * Consultar reportes success.
   */
  useUpdateEffect(() => {
    if (props?.consultarReportesData?.data?.length === 0) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: "No se encontraron registros.",
        onConfirm: () => {
          setShowAlert(false);
        }
      });
      setShowAlert(true);
    }
  }, [props.consultarReportesData]);

  /**
   * Consultar reportes Error.
   */
  useUpdateEffect(() => {
    if (
      !isObjectEmpty(props?.consultarReportesError) &&
      !props?.consultarReportesLoading
    ) {
      mostrarErrorGenerico(
        props?.consultarReportesError,
        () => {},
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.consultarReportesError]);

  /**
   * Exportar Excel Success.
   */
  useUpdateEffect(() => {
    if (
      !isObjectEmpty(props?.exportarReportesExcelData) &&
      !props?.exportarReportesExcelLoading
    ) {
      setAlertConfig({
        type: "success",
        title: "¡Éxito!",
        message:
          props?.exportarReportesExcelData?.mensaje ||
          "El reporte se generó exitosamente",
        onConfirm: () => {
          setShowAlert(false);
        }
      });
      setShowAlert(true);
    }
  }, [props.exportarReportesExcelData]);

  /**
   * Exportar Excel Error.
   */
  useUpdateEffect(() => {
    if (
      !isObjectEmpty(props?.exportarReportesExcelError) &&
      !props?.exportarReportesExcelLoading
    ) {
      mostrarErrorGenerico(
        props?.exportarReportesExcelError,
        () => {},
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.exportarReportesExcelError]);

  const onStateChange =
    (key, format = null) =>
    (value) => {
      setFormData((prevState) => ({
        ...prevState,
        [key]: format ? format(value) : value
      }));
    };

  const buscarReportes = (pagina) => {
    const { fechaDesde, fechaHasta } = formData;

    let mensajeValidacion = null;

    if (!camposCompletos({ fechaDesde, fechaHasta })) {
      mensajeValidacion = ALERTAS_GENERICAS.CAMPOS_REQUERIDOS;
    } else if (moment(fechaDesde).isAfter(fechaHasta)) {
      mensajeValidacion = ALERTAS_GENERICAS.FECHA_DESDE_HASTA_INVALIDA;
    }

    if (mensajeValidacion) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: mensajeValidacion,
        onConfirm: () => {
          setShowAlert(false);
        }
      });
      setShowAlert(true);
      return;
    }

    props.consultarReportes({
      ...formData,
      compania: empresa?.CODIGO,
      pagina: pagina,
      tamanoPagina: itemsPerPage
    });
  };

  const exportar = (tipo) => {
    const { fechaDesde, fechaHasta } = formData;

    let mensajeValidacion = null;

    if (!camposCompletos({ fechaDesde, fechaHasta })) {
      mensajeValidacion = ALERTAS_GENERICAS.CAMPOS_REQUERIDOS;
    } else if (moment(fechaDesde).isAfter(fechaHasta)) {
      mensajeValidacion = ALERTAS_GENERICAS.FECHA_DESDE_HASTA_INVALIDA;
    }

    if (mensajeValidacion) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: mensajeValidacion,
        onConfirm: () => {
          setShowAlert(false);
        }
      });
      setShowAlert(true);
      return;
    }

    props.exportarReportesExcel({
      ...formData,
      compania: empresa?.CODIGO,
      tipo: tipo
    });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    buscarReportes(page);
  };

  const showModalLoader = () => {
    return props.consultarReportesLoading || props.exportarReportesExcelLoading;
  };

  const getReportes = () => {
    return props?.consultarReportesData?.data || [];
  };

  const getTotalRegistros = () => {
    return props?.consultarReportesData?.paginacion?.totalRegistros || 0;
  };

  const columns = [
    {
      title: "No. Solicitud",
      key: "numeroSolicitud",
      dataIndex: "numeroSolicitud",
      width: "200px"
    },
    {
      title: "PSS",
      key: "pss",
      dataIndex: "pss",
      width: "250px"
    },
    {
      title: "Tipo PSS",
      key: "tipoPss",
      dataIndex: "tipoPss",
      width: "150px"
    },
    {
      title: "Nomobre Asegurado",
      key: "nombreAsegurado",
      dataIndex: "nombreAsegurado",
      width: "200px"
    },
    {
      title: "Asegurado No.",
      key: "asegurado",
      dataIndex: "asegurado",
      width: "200px"
    },
    {
      title: "No. Autorización",
      key: "numeroAutorizacion",
      dataIndex: "numeroAutorizacion",
      width: "150px"
    },
    {
      title: "Fecha",
      key: "fecha",
      dataIndex: "fecha",
      width: "150px",
      render: (text) => <span>{moment(text).format("L")}</span>
    },
    {
      title: "Estado",
      key: "estado",
      dataIndex: "estado",
      width: "150px"
    },
    {
      title: "Tiempo",
      key: "tiempo",
      dataIndex: "tiempo",
      width: "100px"
    },
    {
      title: "Plan",
      key: "plan",
      dataIndex: "plan",
      width: "250px"
    },
    {
      title: "Usuario Asignado",
      key: "usuario",
      dataIndex: "usuario",
      width: "250px"
    },
    {
      title: "Comentarios",
      key: "comentarios",
      dataIndex: "comentarios",
      width: "250px"
    }
  ];

  useUpdateEffect(() => {
    setShowAlert(false);
    setAlertConfig({});
  }, []);

  return (
    <>
      <Section>
        <TittleLine title={"Generar Reportes"} />
      </Section>

      <Section>
        <StandVirtualReportesBusquedaForm
          {...formData}
          onStateChange={onStateChange}
          onSearch={() => buscarReportes(currentPage)}
          onExport={exportar}
          isLoading={
            props.consultarReportesLoading || props.exportarReportesExcelLoading
          }
          isLoadingCatalogos={props.obtenerCatalogosReportesLoading}
        />
      </Section>

      <Section
        style={{
          padding: "0px",
          flexDirection: "column",
          gap: "10px",
          alignItems: "center"
        }}
      >
        <CheckRender allowed={getReportes()?.length > 0}>
          <CustomTable
            columns={columns}
            dataSource={getReportes()}
            showPagination={false}
            pageSize={itemsPerPage}
            width={"100%"}
          />
          <Pagination
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            totalItems={getTotalRegistros()}
            onPageChange={handlePageChange}
          />
        </CheckRender>
      </Section>

      <CheckRender allowed={showModalLoader()}>
        <ModalLoader />
      </CheckRender>

      <CheckRender allowed={showAlert}>
        <CustomAlert {...alertConfig} />
      </CheckRender>
    </>
  );
};

const mapStateToProps = (state) => ({
  consultarReportesData: state.reportes.consultarReportesData,
  consultarReportesLoading: state.reportes.consultarReportesLoading,
  consultarReportesError: state.reportes.consultarReportesError,

  exportarReportesExcelData: state.reportes.exportarReportesExcelData,
  exportarReportesExcelLoading: state.reportes.exportarReportesExcelLoading,
  exportarReportesExcelError: state.reportes.exportarReportesExcelError
});

const mapDispatchToProps = {
  consultarReportes: ReportesActions.consultarReportes,
  exportarReportesExcel: ReportesActions.exportarReportesExcel,
  limpiarReportes: ReportesActions.limpiarReportes
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(StandVirtualReportesScreen);
